var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "projectCard" },
    [
      _vm.project
        ? _c("PageHeadContainer", {
            staticClass: "customMinHeight customPaddingRes",
            attrs: {
              title: _vm.project.client_name,
              heigthStyle: "minHeightRes",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "status",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex mb-4 sm:mb-3" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-storm-gray text-base font-medium leading-normal",
                            },
                            [_vm._v(" " + _vm._s(_vm.age) + " ")]
                          ),
                          _c("span", { staticClass: "line text-center" }, [
                            _vm._v("|"),
                          ]),
                          _vm.gender
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "text-storm-gray text-base font-medium leading-normal",
                                },
                                [_vm._v(" " + _vm._s(_vm.gender) + " ")]
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "text-storm-gray text-base font-medium leading-normal",
                                },
                                [_vm._v(" n/a ")]
                              ),
                          _vm.projectCompleted
                            ? _c("CardInfoChip", {
                                staticClass: "ml-2",
                                attrs: { message: "Closed" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "mb-4 flex flex-row sm:hidden" },
                        [
                          _c("LocationIcon", { staticClass: "h-4 w-4 mr-2.5" }),
                          _vm.location
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "text-blue text-sm font-normal hover:underline leading-4",
                                  attrs: {
                                    href: _vm.googleMapsLink,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.location) + " ")]
                              )
                            : _c(
                                "p",
                                {
                                  staticClass: "text-blue text-sm font-normal",
                                },
                                [_vm._v("n/a")]
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "avatar",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex sm:flex-row flex-col-reverse justify-between items-end sm:items-center",
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-gray-new font-normal mr-auto sm:mr-0 text-xs sm:text-sm leading-4 sm:leading-5 mb-3 sm:mb-1 sm:mt-1",
                            },
                            [_vm._v(" " + _vm._s(_vm.createdAt) + " ")]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "icons",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex flex-row mb-1.5 sm:mb-1" },
                        [
                          _c("UserIcon", { staticClass: "mr-2" }),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-sm sm:text-base text-primary-black customLineHet font-semibold mr-0.5",
                            },
                            [_vm._v(" Client ID: ")]
                          ),
                          _c("p", { staticClass: "details" }, [
                            _vm._v(_vm._s(_vm.clientId)),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-row mb-4 items-center" },
                        [
                          _c("StarIcon", { staticClass: "mr-2" }),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-sm sm:text-base text-primary-black customLineHet font-semibold mr-0.5",
                            },
                            [_vm._v(" Type of work: ")]
                          ),
                          _c("p", { staticClass: "details" }, [
                            _vm._v(_vm._s(_vm.typeOfWork)),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "flex flex-col mb-4" }, [
                        _c(
                          "div",
                          { staticClass: "flex flex-row items-center" },
                          [
                            _c("ContactIcon", { staticClass: "mr-2" }),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-sm sm:text-base text-primary-black customLineHet font-semibold",
                              },
                              [_vm._v(" Buzzer: ")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "flex flex-row mb-1 gap-3" }, [
                          _c("p", { staticClass: "details" }, [
                            _vm._v(_vm._s(_vm.buzzer)),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col sm:flex-row gap-3 sm:gap-10 mediumMinHeight",
                        },
                        [
                          _c("div", [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-primary-black font-medium text-sm sm:text-base customLineHet mb-2 sm:mb-4",
                              },
                              [_vm._v(" Manager ")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-row gap-2 items-center",
                              },
                              [
                                _vm.managerLink
                                  ? _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-nav-gray text-sm font-medium pointer-events-none rounded-full block border border-gray-300 bg-white borderCard hover:text-primary-500 hover:border-primary-500",
                                        },
                                        [
                                          _vm.project.manager.user
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row items-center",
                                                  attrs: {
                                                    name: "imageAvatar",
                                                    image:
                                                      _vm.project.manager.user
                                                        .avatar,
                                                  },
                                                },
                                                [
                                                  _vm.project.manager.user
                                                    .avatar !== null
                                                    ? _c("S3Image", {
                                                        class: [
                                                          _vm.defaultImageClasses,
                                                        ],
                                                        attrs: {
                                                          s3FileKey:
                                                            _vm.project?.manager
                                                              ?.user?.avatar,
                                                        },
                                                      })
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-xs leading-none font-medium mr-1",
                                                          class:
                                                            _vm.getAvatrClass,
                                                          style: _vm.bgStyle,
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.initial
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-storm-gray chipText font-normal",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.project.manager
                                                              .user.given_name
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.project.manager
                                                              .user.family_name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-normal text-base text-storm-gray flex items-center",
                                      },
                                      [_vm._v(" n/a ")]
                                    ),
                                _vm.managerLink
                                  ? _c(
                                      "button",
                                      {
                                        on: {
                                          click: _vm.message,
                                          mouseover: function ($event) {
                                            _vm.isHoveredChat = true
                                          },
                                          mouseout: function ($event) {
                                            _vm.isHoveredChat = false
                                          },
                                        },
                                      },
                                      [
                                        !_vm.isHoveredChat
                                          ? _c("ChatIcon", {
                                              staticClass: "h-7 w-7",
                                            })
                                          : _vm._e(),
                                        _vm.isHoveredChat
                                          ? _c("ChatIcon", {
                                              staticClass: "h-7 w-7",
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "location",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "hidden sm:flex flex-row gap-2 customMargin",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              staticStyle: { width: "234px" },
                            },
                            [
                              _vm.location !== "n/a"
                                ? _c("LocationImage", {
                                    attrs: { location: _vm.location },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "mx-1 my-2 flex flex-row" },
                                [
                                  _c("LocationIcon", {
                                    staticClass: "h-4 w-4 mr-2.5 iconStyle",
                                  }),
                                  _vm.location
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-blue text-base font-normal hover:underline customLineHet",
                                          attrs: {
                                            href: _vm.googleMapsLink,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.location) + " "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-blue text-sm font-normal",
                                        },
                                        [_vm._v("n/a")]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1031734027
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }